import { makeStyles } from '@mui/styles';
import CheckBox from 'apollo-react/components/Checkbox';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setSelectedControlObject,
  updateControlProperty,
} from '../../../actions/report-designer.actions';
import {
  getHasValidationErrorByIdAndProp,
  getSelectedControlId,
} from '../../../selectors/report-designer.selectors';
import { getPropertyValueToDisplay } from '../../../utils/report-designer.utils';

const useStyles = makeStyles({
  selected: {
    '& svg': {
      fill: 'white !important',
    },
    '& [class*="MuiCheckbox-root"] svg path:nth-of-type(2)': {
      fill: '#0768fd !important',
    },
  },
});

const CheckBoxCell = ({ row, column, inSubRow }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { controlId, selected } = row;
  const { accessor } = column;

  const selectedControlId = useSelector(getSelectedControlId);
  const hasValidationError = useSelector((state) =>
    getHasValidationErrorByIdAndProp(state, { id: controlId, prop: accessor })
  );

  const value = getPropertyValueToDisplay(row[accessor]);

  const handleChange = ({ target: { checked } }) => {
    dispatch(updateControlProperty(controlId, accessor, checked));

    if (controlId !== selectedControlId) {
      dispatch(setSelectedControlObject(controlId, false));
    }
  };

  return (
    <div className={selected && !inSubRow ? classes.selected : null}>
      <CheckBox
        id={`${accessor}|${controlId}`}
        checked={value}
        onChange={handleChange}
        error={hasValidationError}
      />
    </div>
  );
};

export default CheckBoxCell;
